import { useState, useEffect } from "react";
import { EU_COUNTRIES } from "../../utils/lang";
import "./DownloadInfos.scss";

function DownloadInfos({ onRequestContact }) {
  const [region, setRegion] = useState("europe");

  useEffect(() => {
    fetch("https://ipapi.co/json/")
      .then((res) => res.json())
      .then((data) => {
        if (EU_COUNTRIES.includes(data.country_code)) {
          setRegion("europe");
        } else {
          setRegion("world");
        }
      })
      .catch(() => {
        setRegion("europe");
      });
  }, []);

  return (
    <div className="downloadInfos">
      <div className="container">
        <div>
          <p>
            I was planning to distribute Flowcam through AltStore to avoid paying €100/year for an
            Apple Developer account... but turns out, you still need one anyway 😅.
          </p>
          <br />
          <p>So for now, I can’t share the app just yet — but I hope to make it available soon!</p>
          <br />
          <p>
            If you have any idea how I could share the app with you,{" "}
            <span
              onClick={onRequestContact}
              style={{ textDecoration: "underline", cursor: "pointer" }}
            >
              reach out
            </span>
            !
          </p>

          <div />
        </div>
      </div>
    </div>
  );
}

export default DownloadInfos;
